// extracted by mini-css-extract-plugin
export default {"icon_button":"styles_icon_button__YG8GZ"};